import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "@phosphor-icons/react";

const KEY = "pr.cookie.consent";

export const CookieConsent = () => {
  const [accepted, setAccepted] = useState(() => {
    try { return localStorage.getItem(KEY) === "accepted"; } catch { return false; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!accepted) {
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    }
  }, [accepted]);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch { /* storage unavailable */ }
    setAccepted(true);
    setOpen(false);
  };

  return (
    <div className={`fixed bottom-4 left-4 z-[60] ${accepted ? "hidden sm:block" : ""}`} data-testid="cookie-consent-root">
      {open && (
        <div
          className="absolute bottom-14 left-0 w-[300px] rounded-2xl p-5"
          style={{
            background: "var(--pr-card)",
            border: "0.5px solid var(--pr-card-border)",
            boxShadow: "inset 0 0 0 0.5px var(--pr-card-border), var(--pr-card-shadow-premium)",
          }}
          data-testid="cookie-consent-panel"
        >
          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3"
            style={{ color: "var(--pr-muted)" }}
            aria-label="Close"
            data-testid="cookie-consent-close"
          >
            <X className="w-4 h-4" />
          </button>
          <p className="text-sm font-bold mb-1" style={{ color: "var(--pr-ink)" }}>We use cookies</p>
          <p className="text-xs leading-relaxed mb-3" style={{ color: "var(--pr-ink2)" }}>
            A few small cookies help us keep you signed in and improve your experience.
            No ad tracking, no selling your data.
          </p>
          <button
            onClick={accept}
            className="w-full py-2.5 rounded-full font-bold text-sm transition-transform hover:scale-[1.02]"
            style={{ background: "#F5CB5C", color: "var(--pr-ink)" }}
            data-testid="cookie-consent-accept"
          >
            Accept
          </button>
          <p className="text-center mt-2">
            <Link to="/privacy-policy" className="text-[11px] underline" style={{ color: "var(--pr-muted)" }} data-testid="cookie-consent-privacy-link">
              Privacy Policy
            </Link>
          </p>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-11 h-11 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
        style={{ background: "#2A1E5C", border: "2px solid rgba(245,203,92,0.6)" }}
        aria-label="Cookie settings"
        data-testid="cookie-consent-icon"
      >
        <Cookie className="w-5 h-5" style={{ color: "#F5CB5C" }} />
      </button>
    </div>
  );
};

export default CookieConsent;
